<template>
  <div class="grid__layout">
    <v-container
      fluid
      grid-list-lg
      class="pa-2 follower-container"
      >
      <v-layout row wrap>
        <v-flex
          :key="i"
          v-for="(item, i) in home.programmes">
          <v-card
            @mouseover.native="cardHover"
            @mouseleave.native="cardLeave"
            dark
            ripple
            class="transparent project-card"
            flat
            exact
            :href="item.link">
            <v-img
              color="secondary"
              :src="item.thumbnail"
              height="200px"
              class="pa-2"
              :class="item.classMedia"
              @contextmenu.prevent="preventRightClick"
              >
              <v-layout
                class="justify-end align-end fill-height grid__layout--text"
                >
                <v-card-text class="fade__gradient--overlay">
                  <h3
                    class="font__weight--bold"
                    v-html="trans(item.title)"
                    >
                  </h3>
                </v-card-text>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style lang="stylus" scoped>
.left {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  overflow: hidden;
}

.right {
  -moz-transform: scaleX(1);
  -o-transform: scaleX(1);
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
  overflow: hidden;
}

#bee {
  transition: transform .1s
  overflow: hidden;
}
</style>

<script>
import store from '@/store'
import Law from '@/modules/CDA/Home/assets/images/law.png'
import Act from '@/modules/CDA/Home/assets/images/act.png'
import Governance from '@/modules/CDA/Home/assets/images/governance.png'
import Strategic from '@/modules/CDA/Home/assets/images/strategic.png'
import Performance from '@/modules/CDA/Home/assets/images/performance.png'

export default {
  store,

  name: 'GridLayoutWeb',

  components: {
  },

  data () {
    return {
      home: {
        programmes: [
          {
            title: 'Cybersecurity Law & Cyber Terrorism',
            thumbnail: Law,
            link: '/programmes/cybersecurity-law-and-cyber-terrorism',
          },
          {
            title: 'Cybersecurity Act 2018 Compliance',
            thumbnail: Act,
            link: '/programmes/cybersecurity-act-2018-compliance',
          },
          {
            title: 'Cybersecurity Governance, Risk & Compliance',
            thumbnail: Governance,
            link: '/programmes/cybersecurity-governance-risk-and-compliance',
          },
          {
            title: 'Strategic Cybersecurity Risk Management',
            thumbnail: Strategic,
            link: '/programmes/strategic-cybersecurity-risk-management',
          },
          {
            title: 'Cybersecurity Performance Management',
            thumbnail: Performance,
            link: '/programmes/cybersecurity-performance-management',
          }
        ]
      }
    }
  },

  mounted () {
    this.preventRightClick()
    // this.followMouse()
  },

  methods: {
    cardHover () {
      let invisible = document.querySelector('.hide-on-hover')
      invisible.classList.add('hide-on-hover--active')
    },

    cardLeave () {
      let invisible = document.querySelector('.hide-on-hover')
      invisible.classList.remove('hide-on-hover--active')
    },

    preventRightClick () {
      return false
    },

    followMouse () {
      /*eslint-disable*/
      var bee = document.getElementById("bee");
      document.addEventListener("mousemove", getMouse);

      bee.style.position = "absolute"; //css
      var beepos = {x:0, y:0};

      setInterval(followMouse, 30);

      var mouse = {x:0, y:0}; //mouse.x, mouse.y

      var dir = "right";
      function getMouse(e){
        mouse.x = e.pageX;
        mouse.y = e.pageY;
        //Checking directional change
        if(mouse.x > beepos.x){
          dir = "right";
        }
      }

      function followMouse(){
        //1. find distance X , distance Y
        var distX = mouse.x - beepos.x;
        var distY = mouse.y - beepos.y;
        //Easing motion
         //Progressive reduction of distance
        beepos.x += distX/5;
        beepos.y += distY/2;

        bee.style.left = beepos.x + "px";
        bee.style.top = beepos.y + "px";

        //Apply css class
        if (dir == "right"){
          bee.setAttribute("class", "right");
        } else {
          bee.setAttribute("class", "left");
        }
      }
    }
  },
}
</script>
